
import { useEffect, useMemo } from "react";
import { logState } from "@/utils/debugLogger";

/**
 * Hook for tracking movie card visual properties like favorites and watchlist states
 */
export const useCardProperties = (
  movieTitle: string, 
  showAsFavorite: boolean,
  showAsPlanToWatch: boolean,
  lookupKey: string,
  shouldDebug: boolean
) => {
  // Final state logging - only for debug movies and logged once when important values change
  useEffect(() => {
    if (shouldDebug) {
      logState("Movie card properties updated", {
        title: movieTitle,
        showAsFavorite,
        showAsPlanToWatch,
        lookupKey
      });
    }
  }, [movieTitle, showAsFavorite, showAsPlanToWatch, lookupKey, shouldDebug]);

  // FIXED: Create a stable key that excludes favorite/planToWatch status to prevent remounts
  const generateCardKey = (currentTab?: string, isSearchResult?: boolean) => {
    return `${lookupKey}-${currentTab}-${isSearchResult ? 'search' : 'regular'}`;
  };

  return {
    generateCardKey
  };
};
